import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: Index,
  loader: () => {
    // TODO: Remove this after migrate fully to supabase from Auth0
    const searchParams = new URLSearchParams(window.location.search);
    const isAuth0Callback = searchParams.has('code') && searchParams.has('state');

    if (isAuth0Callback) {
      return;
    }

    redirect({ href: '/visits', throw: true });
  },
});

function Index() {
  return <></>;
}
